export type WebUpdateErrorCode =
  'unavailable' | 'download' | 'activation' | 'timeout';

export class WebUpdateError extends Error {
  constructor(
    public readonly code: WebUpdateErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'WebUpdateError';
  }
}
